(function () {
  const slideshow = () => {
    $(document).ready(function () {
      $(".js-slideshow").each(function (index, parent) {
        let parentId = `#${$(parent).attr("id")}`;

        const params = document
          .querySelector(parentId)
          .querySelector(".js-data--slideshow");

        const speedSlideing = removeSpace(params.dataset.speedSlideing) * 1000;
        const delaySlideing = removeSpace(params.dataset.delaySlideing) * 1000;
        let isHoverStopAutoplay = toBoolean(params.dataset.isHoverStopAutoplay);
        const isAutoplay = toBoolean(params.dataset.isAutoplay);
        isHoverStopAutoplay =
          isAutoplay === false ? false : isHoverStopAutoplay;
        const parallax = toBoolean(params.dataset.parallax);
        const effects = params.dataset.effects;

        const circleAnimateName = "circle-animate";
        const jsSwiperName = "js-swiper";
        const jsSwiper = `${parentId} .${jsSwiperName}`;
        let isHover = false;

        const slideEffects = (effects) => {
          switch (effects) {
            case "slide":
              return {};
            case "fade":
              return { effect: "fade", parallax: false };
            case "coverflow":
              return {
                effect: "coverflow",
                coverflowEffect: {
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                },
              };
            case "creative":
              return {
                effect: "creative",
                creativeEffect: {
                  prev: {
                    shadow: true,
                    translate: [0, 0, -400],
                  },
                  next: {
                    translate: ["100%", 0, 0],
                  },
                },
              };
            case "flip":
              return { effect: "flip" };
            default:
              return {};
          }
        };

        const insertAutoplay = () =>
          isAutoplay === true
            ? {
                autoplay: {
                  delay: delaySlideing,
                  disableOnInteraction: false,
                },
              }
            : {};

        // Swiper Parameters without Pagination
        const swiperParams = {
          centeredSlides: false,
          speed: speedSlideing,
          loop: false,
          parallax: parallax,
          ...slideEffects(effects),
          ...insertAutoplay(),

          on: {
            init: function () {
              if (isHover === false) {
                removePageAnimationClassName();
                addPageAnimationClassName();
              }
            },
            transitionStart: function () {
              if (isHover === false) {
                removePageAnimationClassName();
              }
            },
            transitionEnd: function () {
              if (isHover === false) {
                addPageAnimationClassName();
              }
            },
          },
        };

        const swiper = new Swiper(jsSwiper, swiperParams);

        $(jsSwiper).mousemove(function () {
          if (isHoverStopAutoplay === true) {
            isHover = true;
            stopSlide();
          }
        });

        $(jsSwiper).mouseenter(function () {
          if (isHoverStopAutoplay === true) {
            isHover = true;
            stopSlide();
          }
        });

        $(jsSwiper).mouseleave(function () {
          if (isHoverStopAutoplay === true) {
            isHover = false;
            startSlide();
          }
        });

        function addPageAnimationClassName() {
          $(`${parentId} .swiper-pagination-bullet-active svg circle:last-child`).addClass(
            circleAnimateName
          );
        }

        function removePageAnimationClassName() {
          $(`${parentId} .circle-button svg circle:last-child`).removeClass(
            circleAnimateName
          );
        }

        function startSlide() {
          if (isAutoplay === true) {
            swiper.autoplay.start();
            addPageAnimationClassName();
          }
        }

        function stopSlide() {
          swiper.autoplay.stop();
          removePageAnimationClassName();
        }

        function toBoolean(stringValue) {
          return removeSpace(stringValue) === "true" ? true : false;
        }

        function removeSpace(stringValue) {
          return stringValue?.split(/\s+/).join("");
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    document.addEventListener("shopify:section:load", function () {
      slideshow();
    });
  });
})();
